import Vue from "vue";
import VueRouter from "vue-router";

Vue.use(VueRouter);

const routes = [
  {
    path: "/:id",
    name: "waterData",
    component: () => import("@/views/waterData")
  }
];

const router = new VueRouter({
  routes
});

export default router;
